/** The amount of time to wait for the second click (double click) on an item. */
const DBL_CLICK_TIMEOUT = 301

module.exports = {
    DBL_CLICK_TIMEOUT
}